import React from 'react';
import { companyInfo } from '../data/mock';
import { ArrowRight, Phone } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const Hero = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <p className="hero-company-name">
            {language === 'ar' ? 'إنجاز للخدمات التجارية والاستشارات الإدارية' : 'Enjaz Commercial Services and Management Consultancy'}
          </p>
          <h1 className="display-huge hero-title">
            {t('hero.title')}
          </h1>
          <p className="body-large hero-subtitle">
            {t('hero.subtitle')}
          </p>
          <div className="hero-cta-group">
            <button 
              onClick={() => scrollToSection('contact')}
              className="btn-primary"
            >
              {t('hero.ctaPrimary')}
              <ArrowRight size={20} />
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="btn-secondary"
            >
              {t('hero.ctaSecondary')}
            </button>
          </div>
          <div className="hero-contact-info">
            <Phone size={20} />
            <span className="body-medium">{companyInfo.contact.phone1} • {companyInfo.contact.phone2}</span>
          </div>
        </div>
        
        <div className="hero-image-container">
          <img 
            src="https://images.unsplash.com/photo-1719561940608-ee6e2ef33d23" 
            alt="Gulf business professionals"
            className="hero-image"
          />
        </div>
      </div>

      {/* Stats Section */}
      <div className="stats-section">
        {companyInfo.stats.map((stat, index) => (
          <div key={index} className="stat-item">
            <h3 className="display-medium stat-number">{stat.number}</h3>
            <p className="body-medium stat-label">{t(`stats.${stat.key}`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
